import { RestaurantCard } from '../../components/RestaurantCard.jsx';
import { placePhotoUrl } from '../../lib/api.js';

/**
 * A catalogue venue, drawn as the product's card.
 *
 * All this does is map a `Restaurant` onto {@link RestaurantCard}: the photo
 * reference becomes a proxied URL, and cuisine, area and price become the line
 * under the name. The card's appearance lives in the shared component, so the
 * landing page and the restaurant dashboard cannot drift into showing diners
 * and advertisers two different products.
 *
 * @param {object} props
 * @param {(typeof import('./venues.generated.js').venues)[number]} props.venue
 * @param {number} [props.infoOpacity]
 * @param {React.ReactNode} [props.children]
 */
export function VenueCard({ venue, infoOpacity = 1, children }) {
  return (
    <RestaurantCard
      photoUrl={venue.photo ? placePhotoUrl(venue.photo) : null}
      name={venue.name}
      meta={[venue.cuisine, venue.neighborhood, venue.price].filter(Boolean).join(' · ')}
      rating={venue.rating}
      infoOpacity={infoOpacity}
    >
      {children}
    </RestaurantCard>
  );
}
